module.exports = __webpack_public_path__ + "img/lunbo23.06f52f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo23.jpg
// module id = VP4M
// module chunks = 0